import React from 'react';
import PropTypes from 'prop-types';
import FormikAutocomplete from './FormikAutocomplete';

import CustomerService from 'services/CustomerService';

function CustomerAutocomplete({ getSuggestionLabel, ...others }) {
  const handleSearchTerm = (inputValue, setIsLoading) => {
    setIsLoading(true);
    return CustomerService.search(inputValue)
      .then((data) => {
        return data;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <FormikAutocomplete
      onChangeSearchTerm={handleSearchTerm}
      getSuggestionLabel={getSuggestionLabel}
      placeholder="Selectione..."
      {...others}
    />
  );
}

CustomerAutocomplete.defaultProps = {
  getSuggestionLabel: (object) => {
    return object.name;
  },
  onChange: () => {},
};
CustomerAutocomplete.propTypes = {
  getSuggestionLabel: PropTypes.func,
  onChange: PropTypes.func,
};
export default CustomerAutocomplete;
